import { Plane, UserX, Lock } from "lucide-react";

export const HOUR_PX = 48;
export const SNAP_MIN = 30;
export const DAY_MS = 86400000;

export const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const startOfWeek = (d) => { const x = startOfDay(d); const off = (x.getDay() + 6) % 7; return addDays(x, -off); };
export const sameDay = (a, b) => a.toDateString() === b.toDateString();

export const hhmm = (d, loc) => d.toLocaleTimeString(loc, { hour: "2-digit", minute: "2-digit" });
export const hourLabel = (h, loc) => { const d = new Date(); d.setHours(h, 0, 0, 0); return d.toLocaleTimeString(loc, { hour: "numeric" }); };

// Grid + legend classes per category (design_guidelines.json event_categories)
export const CATS = {
  available: {
    labelKey: "cal.catAvailable",
    block: "bg-indigo-50/50 border border-dashed border-indigo-300 text-indigo-700",
    dot: "bg-white border border-dashed border-indigo-400",
  },
  booked_coaching: {
    labelKey: "cal.catBookedCoaching",
    block: "bg-indigo-100 border border-indigo-200 text-indigo-900 border-l-4 border-l-indigo-600 shadow-sm",
    dot: "bg-indigo-600",
  },
  pending_tentative: {
    labelKey: "cal.catPending",
    block: "bg-indigo-50 border border-indigo-200 text-indigo-800 border-l-4 border-l-indigo-400 [background-image:repeating-linear-gradient(45deg,transparent,transparent_6px,rgba(99,102,241,0.12)_6px,rgba(99,102,241,0.12)_12px)]",
    dot: "bg-indigo-300",
  },
  external_busy: {
    labelKey: "cal.catBusy",
    block: "bg-slate-100 border border-slate-200 text-slate-600 border-l-4 border-l-slate-400",
    dot: "bg-slate-400",
  },
  conge_leave: {
    labelKey: "cal.cat.leave",
    block: "bg-emerald-100 border border-emerald-200 text-emerald-900 border-l-4 border-l-emerald-600",
    dot: "bg-emerald-500",
  },
  absence: {
    labelKey: "cal.cat.absence",
    block: "bg-rose-100 border border-rose-200 text-rose-900 border-l-4 border-l-rose-600",
    dot: "bg-rose-500",
  },
  personal: {
    labelKey: "cal.cat.personal",
    block: "bg-amber-100 border border-amber-200 text-amber-900 border-l-4 border-l-amber-600",
    dot: "bg-amber-500",
  },
};
export const BLOCK_CAT_TO_EVENT = { leave: "conge_leave", absence: "absence", personal: "personal" };
export const BLOCK_ICON = { leave: Plane, absence: UserX, personal: Lock };
export const LEGEND_ORDER = ["available", "booked_coaching", "pending_tentative", "external_busy", "conge_leave", "absence", "personal"];

// Overlap column layout for a day's events
export function layout(events) {
  const sorted = [...events].sort((a, b) => a.top - b.top || a.bottom - b.bottom);
  let cluster = [], clusterEnd = -1;
  const flush = () => {
    const cols = [];
    cluster.forEach((ev) => {
      let placed = false;
      for (let i = 0; i < cols.length; i++) {
        if (cols[i] <= ev.top + 0.01) { ev._col = i; cols[i] = ev.bottom; placed = true; break; }
      }
      if (!placed) { ev._col = cols.length; cols.push(ev.bottom); }
    });
    cluster.forEach((ev) => { ev._cols = cols.length; });
    cluster = []; clusterEnd = -1;
  };
  sorted.forEach((ev) => {
    if (cluster.length && ev.top >= clusterEnd - 0.01) flush();
    cluster.push(ev);
    clusterEnd = Math.max(clusterEnd, ev.bottom);
  });
  flush();
  return sorted;
}
